import axios from 'axios';

export function sendFeedback({
  response,
  comment,
  originalQueryKey,
}: {
  response: 'YES' | 'NO' | 'PARTIALLY';
  comment: string;
  originalQueryKey: string;
}) {
  return axios.post('/api/search/feedback', {
    response,
    comment,
    original_query_key: originalQueryKey,
  });
}
